import React, { createContext, useState, useContext } from "react";
import { fetchAttemptQuestionsData } from "../services/service";

const AttemptedQuestionsContext = createContext();

function AttemptedQuestionsProvider({ children }) {
  const [attemptedQuestions, setAttemptedQuestions] = useState(null);
  const [attemptedLoader, setAttemptedLoader] = useState(true);

  const fetchAttemptedQuestions = async (examId) => {
    // if (attemptedQuestions) return;
    setAttemptedLoader(true);
    try {
      const AttemptedQuestionsData = await fetchAttemptQuestionsData(examId);
      setAttemptedQuestions(AttemptedQuestionsData.attempted_questions);
      setAttemptedLoader(false);
    } catch (error) {
      console.error("Error fetching Attempted Questions:", error);
    }
  };

  return (
    <AttemptedQuestionsContext.Provider
      value={{ attemptedQuestions, fetchAttemptedQuestions, attemptedLoader }}
    >
      {children}
    </AttemptedQuestionsContext.Provider>
  );
}

const useAttemptedQuestions = () => {
  return useContext(AttemptedQuestionsContext);
};

export { useAttemptedQuestions };
export default AttemptedQuestionsProvider;
